<template>
    <v-btn icon @click="hideIt(comment)">
      <v-icon small class="mx-1" :color="color">mdi-eye-off</v-icon>
    </v-btn>
</template>

<script>

import { chatService } from "../../repositories/ChatService";

export default {
  name: "hide-btn",
  data: () => ({
    color: '#868686',
    colorIsHidden : 'blue',
    colorNormal : '#868686',
    conversationId: null
  }),
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    comment: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.conversationId = this.user._id;
    this.color = this.comment.is_hidden ? this.colorIsHidden : this.colorNormal
  },
  watch: {
    comment : {
      handler: async function (val) {
        this.color = val.is_hidden ? this.colorIsHidden : this.colorNormal
      },
      deep: true,
    },
    user : {
      handler: async function (val) {
        this.conversationId = val._id;
      },
      deep: true,
    }
  },
  methods: {
    async hideIt(comment) {
      if(this.color == this.colorIsHidden) {
        try {
          let res = await chatService.unhideCommentReply(this.conversationId, comment.comment_id);
          if (res) {
            this.color = this.colorNormal;
            this.$swal.fire({
              icon: "success",
              title: 'unhide OK',
              showConfirmButton: false,
              timer: 1500,
            });
          }
        } catch (error) {
          this.$swal.fire({
            icon: "error",
            title: 'Có lỗi xảy ra',
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } else {
        try {
          let res = await chatService.hideCommentReply(this.conversationId, comment.comment_id);
          if (res) {
            this.color = this.colorIsHidden;
            this.$swal.fire({
              icon: "success",
              title: 'OK',
              showConfirmButton: false,
              timer: 1500,
            });
          }
        } catch (error) {
          this.$swal.fire({
            icon: "error",
            title: 'Có lỗi xảy ra',
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    }
  }
}
</script>